/**
 * Asset Behavior Service
 * Handles asset behavior report data fetching
 */

import { IS_MOCK, MOCK_DELAY } from '../../constants/config';
import { generateMockAssetBehaviorData, generateStateHeatmapData } from '../mock/mockAssetBehavior';
import { delay } from '../mock/mockData';
import type { AssetBehaviorData, ReportFilters } from '../../types/reports';

class AssetBehaviorService {
  /**
   * Get asset behavior report data
   */
  static async getAssetBehaviorData(
    filters?: ReportFilters
  ): Promise<AssetBehaviorData> {
    if (IS_MOCK) {
      await delay(MOCK_DELAY / 2);
      return generateMockAssetBehaviorData();
    } else {
      const params = new URLSearchParams();
      
      if (filters?.dateRange) params.append('dateRange', filters.dateRange);
      if (filters?.region) params.append('region', filters.region);
      if (filters?.assetId) params.append('assetId', filters.assetId);
      
      const response = await fetch(`/api/reports/asset-behavior?${params.toString()}`);
      if (!response.ok) {
        throw new Error('Failed to fetch asset behavior data');
      }
      return response.json();
    }
  }

  /**
   * Get state heatmap data
   */
  static async getStateHeatmapData(
    stateCode: string,
    stateName: string
  ): Promise<AssetBehaviorData['stateHeatmapData']> {
    if (IS_MOCK) {
      await delay(MOCK_DELAY / 2);
      return generateStateHeatmapData(stateCode, stateName);
    } else {
      const response = await fetch(`/api/reports/asset-behavior/state/${stateCode}`);
      if (!response.ok) {
        throw new Error('Failed to fetch state heatmap data');
      }
      return response.json();
    }
  }
}

export { AssetBehaviorService };

